export default __webpack_public_path__ + "static/media/ac-brand-tech4.d00e8800.jpg";